import {AbstractParameter} from "./AbstractParameter";
import textareaHtml from './textarea.html?raw';

export let template = textareaHtml;

export class viewModel extends AbstractParameter {

    protected getParams() {
        return {
            dynamicSupport: false,
            expression: this.parameter.val,
            objectTypeId: this.parameter.objectTypeId,
            objectTypeIds: this.parameter.objectTypeIds,
            placeholder: this.getPlaceholder(),
            rows: 3,
        }
    }

}
